import { authVerificationService } from '@/services';
export default {
    async requestAuthVerification({ commit }, payload = {}) {
        const { phone = '' } = payload;
        const response = await authVerificationService.requestAuthVerification({
            phone,
        });
        commit('SET_AUTH_VERIFICATION', response.data);
        return response.data;
    },
    async checkAuthVerification({ commit }, payload = {}) {
        const { authId = '', authCode = '' } = payload;
        const response = await authVerificationService.checkAuthVerification({
            authId,
            authCode,
        });
        commit('SET_AUTH_VERIFICATION', response.data);
        return response.data;
    },
};
